import { render, staticRenderFns } from "./LanguageDetailCard.vue?vue&type=template&id=79454143"
import script from "./LanguageDetailCard.vue?vue&type=script&lang=js"
export * from "./LanguageDetailCard.vue?vue&type=script&lang=js"
import style0 from "./LanguageDetailCard.vue?vue&type=style&index=0&id=79454143&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports